<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-4">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'createNewUser.userInfor.cropPhotoTitle' | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>

  <div class="rounded-3xl w-full h-full overflow-hidden">
    <image-cropper
      [resizeToHeight]="512"
      [resizeToWidth]="512"
      class="h-full"
      [imageFile]="imageFile"
      [maintainAspectRatio]="true"
      [aspectRatio]="4 / 4"
      format="png"
      (imageCropped)="imageCropped($event)"
    ></image-cropper>
  </div>

  <div class="flex justify-end items-center gap-4">
    <button mat-stroked-button color="secondary" [disabled]="!imageBlob" (click)="onUpload()">
      {{ 'createNewUser.userInfor.btnUpload' | translate }}
    </button>
  </div>
</div>
